'use strict'

module.exports = {
    UPLOADED_FONT_PREFIX: 'wf_',
    LONG_UPLOADED_FONT_PREFIX: 'wfont_',
    POSSIBLE_CHARACTERS_SETS: ['latin-ext', 'cyrillic', 'japanese', 'korean', 'arabic', 'hebrew', 'latin']
}